import { render, staticRenderFns } from "./MovimientoFilters.vue?vue&type=template&id=673b15e4&scoped=true&"
import script from "./MovimientoFilters.vue?vue&type=script&lang=js&"
export * from "./MovimientoFilters.vue?vue&type=script&lang=js&"
import style0 from "./MovimientoFilters.vue?vue&type=style&index=0&id=673b15e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673b15e4",
  null
  
)

export default component.exports